import React, { useEffect } from "react";
import icons from "../../../assets/images/constantIcons";
import { useDispatch, useSelector } from "react-redux";
import { getOrdersDetails, updateRequestStatus } from "../../CanteenUsers/OrderSlice";
import { handleError } from "../../Common/ApiCommon/ApiService";
import toast from "react-hot-toast";

const ViewOrder = ({ isOpen, onClose, id }) => {
  const dispatch = useDispatch();
  const { orderData, loading } = useSelector((state) => state?.orders || {});
  const [confirmation, setConfirmation] = React.useState({ open: false, action: null });

  const proceedAction = async () => {
    try {
      const response = await dispatch(updateRequestStatus({ id: id, status: confirmation.action })).unwrap();
      toast.success(response.message, { duration: 2000 });
      setConfirmation({ open: false, action: null });
      onClose();
    } catch (errors) {
      handleError(errors);
      setConfirmation({ open: false, action: null });
    }
  };


  useEffect(() => {
    if (id) {
      dispatch(getOrdersDetails(id));
    }
  }, [id, dispatch]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString('en-US', options);
  };

  if (loading) return <p>Loading ....</p>

  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[500px] relative">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">View Order</h2>
            <div
              className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
              onClick={onClose}
            >
              <icons.IoClose className="text-green700" />
            </div>
          </div>
          <div className="bg-white w-full rounded-2xl ">
            <div className="bg-white rounded-2xl">
              <div className="flex justify-between text-G500">
                <p className="text-lg font-semibold">
                  Order ID <span>{orderData?.order_uniq_id}</span>
                </p>
                <p className="text-sm font-medium">{orderData?.user?.full_name}</p>
              </div>
              <div className="flex justify-between text-G100 text-xs mt-2">
                <p>{formatDate(orderData?.date)}</p>
                <p className="">
                  <span className="bg-green50 text-green rounded-lg px-2 py-1"> {orderData?.order_type}</span>
                </p>
              </div>
              <hr className="border-b-[1px] border-G30 my-2" />
              <p className="text-sm font-semibold mb-2">Order</p>
              <div className="flex flex-col gap-5 text-G500 text-sm my-2  max-h-56 overflow-y-auto vertical">
                {orderData?.order_items?.map((item, idx) => (
                  <div key={idx} className="flex justify-between">
                    <div className="flex items-center">
                      <img
                        src={item?.image}
                        alt={item?.item_name}
                        className="w-16 h-16 rounded-full mr-3"
                      />
                      <div className="flex flex-col gap-1">
                        <p className="text-base font-medium">{item?.item_name}</p>
                        <h1>X{item.quantity}</h1>
                      </div>
                    </div>
                    <div className="font-medium">₹ {item?.total_price}</div>
                  </div>
                ))}
              </div>
              <hr className="border-b-[1px] border-G30 " />
              <div className="flex justify-between items-center text-G800 my-3 ">
                <button className="text-xl font-semibold">Total</button>
                <p className="font-semibold text-xl flex">
                  <span className="text-green mr-1">₹</span>
                  {orderData?.total_price}
                </p>
              </div>
              {orderData?.status !== "cancelled" && (
                <div div className="flex justify-start gap-8 ">
                  <button
                    onClick={() => setConfirmation({ open: true, action: "accept" })}
                    className="bg-green text-white rounded-lg py-2 px-6 text-base font-medium"
                  >
                    Accept
                  </button>
                  <button
                    onClick={() => setConfirmation({ open: true, action: "reject" })}
                    className="bg-red text-white rounded-lg py-2 px-6 text-base font-medium"
                  >
                    Reject
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {confirmation.open && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-xl p-6 w-80 text-center shadow-xl">
              <h2 className="text-lg font-semibold mb-4 text-G800">
                Are you sure you want to {confirmation.action} this order?
              </h2>
              <div className="flex justify-center gap-4 mt-4">
                <button
                  onClick={proceedAction}
                  className="bg-green text-white rounded-lg py-[6px] px-4 w-20"
                >
                  Yes
                </button>
                <button
                  onClick={() => setConfirmation({ open: false, action: null })}
                  className="border border-green text-green rounded-lg py-[6px] w-20 text-center"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

      </div >
    )
  );
};

export default ViewOrder;
